@let editViewValue = userService.editView();
@let loadingUserListValue = userService.loadingUserList();
@let isSavingValue = isSaving();
@if (!editViewValue) {
  <mat-card appearance="outlined">
    @if (!loadingUserListValue) {
      @let showVideosValue = showVideos();
      <div class="panel">
        <div class="panel__button">
          <!--Button Add User-->
          <button mat-raised-button class="btn-app-edit" (click)="onUserAdd()">
            <fa-icon [icon]="['far', 'user-plus']"></fa-icon>&nbsp;
            {{ 'PRODUCT.USERADMIN.USERLIST.USERADD' | translate }}
          </button>
          &nbsp;
          <!--Button Upload Userlist-->
          <button
            mat-raised-button
            class="btn-app-edit"
            (click)="showUpload.set(true)">
            <fa-icon [icon]="['far', 'upload']"></fa-icon>&nbsp;
            {{ 'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.TITLE' | translate }}
          </button>
          &nbsp;
          <!--Button Show Videos-->
          <button
            mat-raised-button
            class="btn-app-next"
            (click)="showVideos.set(!showVideosValue)">
            <fa-icon [icon]="['far', 'video']"></fa-icon>&nbsp;
            {{ 'PRODUCT.USERADMIN.TUTORIAL' | translate }}
          </button>
          &nbsp;
        </div>
        <!--Search Input Field-->
        <mat-form-field class="mat-form-field-wrapper">
          <input
            matInput
            [(ngModel)]="searchString"
            placeholder="{{ 'PRODUCT.USERADMIN.SEARCH' | translate }}"
            (keyup)="filterUserList()" />
        </mat-form-field>
      </div>
      <!--Upload Userlist-->
      @if (showUpload()) {
        @if (uploadError()) {
          <mat-card appearance="outlined">
            <div class="error-text">
              {{
                'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.WRONGFORMAT' | translate
              }}
            </div>
          </mat-card>
        }
        @if (showUploadPreview()) {
          <mat-card appearance="outlined">
            <mat-card-content>
              <h3>
                {{
                  'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.READDATATITLE'
                    | translate
                }}
              </h3>
              <div>
                {{
                  'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.READDATATEXT1'
                    | translate
                }}
              </div>
              <div>
                {{
                  'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.READDATATEXT2'
                    | translate
                }}
              </div>
              <br />
              <table class="upload-sample-table">
                <tr>
                  <th style="text-align: center !important">
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.VALID' | translate
                    }}
                  </th>
                  <th>
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.NAME'
                        | translate
                    }}
                  </th>
                  <th>
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.EMAIL'
                        | translate
                    }}
                  </th>
                  <th style="text-align: center !important">
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.AUTODELIVERY'
                        | translate
                    }}
                  </th>
                  <th>
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.EMAIL2'
                        | translate
                    }}
                  </th>
                  <th>
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.SMS'
                        | translate
                    }}
                  </th>
                  <th>
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.FAX'
                        | translate
                    }}
                  </th>
                </tr>
                @for (user of validatedUploadUsers(); track $index) {
                  <tr [ngClass]="user.valid ? '' : 'invalid'">
                    <td style="text-align: center !important">
                      @if (user.valid) {
                        <fa-icon
                          [icon]="['far', 'check']"
                          [ngStyle]="{ color: 'green' }"></fa-icon>
                      } @else {
                        <fa-icon
                          [icon]="['far', 'times']"
                          [ngStyle]="{ color: 'red' }"></fa-icon>
                      }
                    </td>
                    <td>
                      {{ user.name }}
                      @if (!user.valid && user.invalidFields[0] === 'name') {
                        <span style="color: red"
                          >Name darf nicht leer sein</span
                        >
                      }
                    </td>
                    <td>
                      {{ user.email }}
                      @if (
                        !user.valid &&
                        user.invalidFields.indexOf('emailWrongFormat') >= 0
                      ) {
                        <span style="color: red">
                          <br />E-Mail Format ist ungültig
                        </span>
                      }
                      @if (
                        !user.valid &&
                        user.invalidFields.indexOf('emailAlreadyExist') >= 0
                      ) {
                        <span style="color: red">
                          <br />Benutzer existiert bereits
                        </span>
                      }
                    </td>
                    <td style="text-align: center !important">
                      @if (user.valid) {
                        @if (user.autodelivery) {
                          <fa-icon [icon]="['far', 'check']"></fa-icon>
                        } @else {
                          <fa-icon [icon]="['far', 'times']"></fa-icon>
                        }
                      }
                    </td>
                    <td>{{ user.email2 }}</td>
                    <td>{{ user.sms | phonenumber }}</td>
                    <td>{{ user.fax | phonenumber }}</td>
                  </tr>
                }
              </table>
            </mat-card-content>
            <mat-card-actions>
              <button
                mat-raised-button
                color="secondary"
                (click)="showUploadPreview.set(false)"
                type="button">
                {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
              </button>
              &nbsp;

              <button
                mat-raised-button
                color="primary"
                (click)="onStartImport()"
                [disabled]="validUsers() === 0"
                type="button">
                {{
                  'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STARTIMPORT'
                    | translate
                }}
              </button>
            </mat-card-actions>
          </mat-card>
        } @else {
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="row">
                <div class="column">
                  <h3>
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STEPS' | translate
                    }}
                  </h3>
                  {{
                    'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STEPSTEXT'
                      | translate
                  }}<br />
                  <ol class="upload-steps">
                    <li>
                      {{
                        'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STEP1'
                          | translate
                      }}
                    </li>
                    <li>
                      {{
                        'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STEP2'
                          | translate
                      }}
                    </li>
                    <li>
                      {{
                        'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STEP3'
                          | translate
                      }}
                    </li>
                    <li>
                      {{
                        'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STEP4'
                          | translate
                      }}
                    </li>
                    <li>
                      {{
                        'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.STEP5'
                          | translate
                      }}
                    </li>
                  </ol>
                </div>
                <div class="column">
                  <h3>
                    {{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.TITLE'
                        | translate
                    }}
                  </h3>
                  <div>
                    [{{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.SAMPLE'
                        | translate
                    }}]
                  </div>
                  <table class="upload-sample-table">
                    <tr>
                      <th>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.NAME'
                            | translate
                        }}
                      </th>
                      <th>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.EMAIL'
                            | translate
                        }}
                      </th>
                      <th>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.AUTODELIVERY'
                            | translate
                        }}
                      </th>
                      <th>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.EMAIL2'
                            | translate
                        }}
                      </th>
                      <th>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.SMS'
                            | translate
                        }}
                      </th>
                      <th>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.FAX'
                            | translate
                        }}
                      </th>
                    </tr>
                    <tr>
                      <td>Max Mustermann</td>
                      <td>max&#64;mustermann.de</td>
                      <td>ja</td>
                      <td>&nbsp;</td>
                      <td>+49 151 12345</td>
                      <td>+49(30)12345-67</td>
                    </tr>
                    <tr>
                      <td>Erika Mustermann</td>
                      <td>erika&#64;mustermann.de</td>
                      <td>nein</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td>Kevin Mustermann</td>
                      <td>kevin&#64;mustermann.de</td>
                      <td>ja</td>
                      <td>kevin&#64;gmx.de</td>
                      <td>0151/12345</td>
                      <td>&nbsp;</td>
                    </tr>
                  </table>
                  &nbsp;
                  <div>
                    [{{
                      'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.DESCRIPTION'
                        | translate
                    }}]
                  </div>
                  <table class="upload-format-table">
                    <tr>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.NAME'
                            | translate
                        }}:
                      </td>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.INFONAME'
                            | translate
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.EMAIL'
                            | translate
                        }}:
                      </td>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.INFOEMAIL'
                            | translate
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.AUTODELIVERY'
                            | translate
                        }}:
                      </td>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.INFOAUTODELIVERY'
                            | translate
                        }}:
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.EMAIL2'
                            | translate
                        }}:
                      </td>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.INFOEMAIL2'
                            | translate
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.SMS'
                            | translate
                        }}:
                      </td>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.INFOSMS'
                            | translate
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.FAX'
                            | translate
                        }}:
                      </td>
                      <td>
                        {{
                          'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.FORMAT.INFOFAX'
                            | translate
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </mat-card-content>
            <mat-card-actions>
              <button
                mat-raised-button
                color="secondary"
                (click)="showUpload.set(false)"
                type="button">
                {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
              </button>
              &nbsp;

              <a
                type="button"
                mat-raised-button
                style="background-color: green; color: white"
                href="/assets/images/usertemplate.csv"
                target="_blank"
                type="button"
                rel="noopener noreferrer">
                <fa-icon [icon]="['far', 'download']"></fa-icon>&nbsp;
                {{
                  'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.DOWNLOADTEMPLATE'
                    | translate
                }}
              </a>
              &nbsp;
              <button
                mat-raised-button
                color="primary"
                (click)="onUsersUpload()"
                type="button">
                <fa-icon [icon]="['far', 'upload']"></fa-icon>&nbsp;
                {{
                  'PRODUCT.USERADMIN.USERLIST.USERUPLOAD.UPLOADCSV' | translate
                }}
              </button>
              <input
                type="file"
                #fileInput
                id="fileUpload"
                name="fileUpload"
                accept="text/comma-separated-values"
                style="display: none" />
            </mat-card-actions>
          </mat-card>
        }
        <br />
      }
      @if (showVideosValue) {
        <mat-card appearance="outlined">
          <button
            mat-icon-button
            style="float: right"
            (click)="showVideos.set(false)">
            <fa-icon [icon]="['far', 'times']"></fa-icon>
          </button>
          <div style="text-align: left">
            <p>
              {{
                'PRODUCT.USERADMIN.USERLIST.MANAGE_USERS_DESCRIPTION'
                  | translate
              }}
            </p>
            @if (!hasUserAdminPermissions()) {
              <p>
                {{
                  'PRODUCT.USERADMIN.USERLIST.ADMIN_PERMISSION_REQUIRED_START'
                    | translate
                }}<b>{{
                  'PRODUCT.USERADMIN.USERLIST.ADMIN_PERMISSION_REQUIRED_BOLD'
                    | translate
                }}</b
                >{{
                  'PRODUCT.USERADMIN.USERLIST.ADMIN_PERMISSION_REQUIRED_END'
                    | translate
                }}
                <a href="mailto:kontakt@wettermanufaktur.de"
                  >kontakt&#64;wettermanufaktur.de</a
                >
              </p>
            }
            <p>
              {{ 'PRODUCT.USERADMIN.USERLIST.TUTORIALS_INTRO' | translate }}
            </p>
            <table width="100%">
              <tr>
                <td width="50%">
                  <iframe
                    [src]="urlTutorialVideo1()"
                    frameborder="0"
                    allowfullscreen
                    width="100%"
                    height="450"></iframe>
                </td>
                <td width="50%">
                  <iframe
                    [src]="urlTutorialVideo2()"
                    frameborder="0"
                    allowfullscreen
                    width="100%"
                    height="450"></iframe>
                </td>
              </tr>
            </table>
          </div>
        </mat-card>
        <p>&nbsp;</p>
      }
      <!--Overview Table User-->
      @let userListValue = userList();
      @if (userListValue.length > 0) {
        <div class="table-card">
          <table
            #userTable
            width="100%"
            class="table"
            cellspacing="0"
            cellpadding="1">
            <!--Tablehead-->
            <tr class="table__title">
              <th>&nbsp;</th>
              <th align="left">
                <fa-icon [icon]="['far', 'sign-in']"></fa-icon>
                {{ 'PRODUCT.USERADMIN.EMAIL' | translate }}
                &nbsp;
              </th>
              <th align="left">
                <fa-icon [icon]="['far', 'user']"></fa-icon>
                {{ 'PRODUCT.USERADMIN.STAMMDATEN.NAME' | translate }}
                &nbsp;
              </th>
              <th>
                <fa-icon [icon]="['far', 'user-check']"></fa-icon>
                {{ 'PRODUCT.USERADMIN.ACTIVE' | translate }}
              </th>
              <th>
                <fa-icon [icon]="['far', 'user-cog']"></fa-icon>
                {{ 'PRODUCT.USERADMIN.ADMINSHORT' | translate }}
              </th>
              <th>
                <fa-icon [icon]="['far', 'globe']"></fa-icon>
                {{ 'PRODUCT.USERADMIN.WEBSITE.TITLE' | translate }}
              </th>
              <th>
                <fa-icon [icon]="['far', 'paper-plane']"></fa-icon>
                {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}
              </th>
              <th>
                <fa-icon [icon]="['far', 'mobile']"></fa-icon>&nbsp;{{
                  'PRODUCT.USERADMIN.APP.TITLE' | translate
                }}
              </th>
              <th>&nbsp;</th>
            </tr>
            @let tableDataValue = tableData();
            <!--Tablebody-->
            <!--
            @for(user of tableDataValue | searchfilter: 'name': 'email' : searchString; track $index; let i = $index) {
              <tr>
            }
            -->
            @if (!tableDataValue.length) {
              <tr class="noTableData">
                <td class="noTableDataMessage" colspan="9">
                  {{ 'PRODUCT.USERADMIN.USERLIST.NO_USERS_FOUND' | translate }}
                </td>
              </tr>
            } @else {
              @for (user of tableDataValue; track $index; let i = $index) {
                <tr>
                  <td>
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="onUserEdit(user)">
                      <fa-icon [icon]="['far', 'edit']" size="lg"></fa-icon>
                    </button>
                  </td>
                  <td>{{ user['email'] }}</td>
                  <td>{{ user['name'] }}</td>
                  <!--Active User Column-->
                  <td align="center">
                    <!--@if(userService.isUserActive(user)) {
                    <fa-icon [icon]="['far','check']"
                                 [styles]="{'color': 'green'}"></fa-icon>
                    }
                        @if(!userService.isUserActive(user)) {
                          <fa-icon [icon]="['far','times']"
                                   [styles]="{'color': 'red'}"></fa-icon>
                        }
                                 -->
                    @let userStatusIconValue = user | userStatusIcon;
                    <fa-icon
                      [icon]="['far', userStatusIconValue.icon]"
                      [ngStyle]="{
                        color: userStatusIconValue.color,
                      }"></fa-icon>
                    <!--Admin Column-->
                  </td>

                  <td align="center">
                    @if (user | isUserAdmin) {
                      <fa-icon
                        [icon]="['far', 'check']"
                        [ngStyle]="{ color: 'green' }">
                      </fa-icon>
                    } @else {
                      <fa-icon
                        [icon]="['far', 'times']"
                        [ngStyle]="{ color: 'red' }">
                      </fa-icon>
                    }
                  </td>
                  <!--Online Access Column-->
                  <td align="center">
                    @let hasUserOnlineAccess = 'online' | hasUserAccess: user;
                    @if (hasUserOnlineAccess) {
                      <span
                        matTooltip="{{
                          'PRODUCT.USERADMIN.USERLIST.ACCESSUNLIMITED'
                            | translate
                        }}">
                        @let isUserAllowedToAccessAllOnlineProducts =
                          'online' | isUserAllowedToAccessAllProducts: user;
                        @if (isUserAllowedToAccessAllOnlineProducts) {
                          <fa-icon
                            [icon]="['far', 'check-double']"
                            [ngStyle]="{ color: 'green' }"></fa-icon>
                        } @else {
                          <ng-container
                            *ngTemplateOutlet="notAllOnlineProducts">
                          </ng-container>
                        }
                      </span>
                    } @else {
                      <ng-container *ngTemplateOutlet="noOnlineAccess">
                      </ng-container>
                    }
                  </td>
                  <!--Delivery Column-->
                  <td align="center">
                    @let hasUserDeliveryAccess =
                      'delivery' | hasUserAccess: user;
                    @let userActiveDeliveryProductIdsValue =
                      'delivery' | userActiveProductIds: user;
                    @if (
                      hasUserDeliveryAccess &&
                      userActiveDeliveryProductIdsValue.length > 0
                    ) {
                      <fa-icon
                        [icon]="['far', 'check']"
                        [ngStyle]="{ color: 'green' }"></fa-icon>
                    }

                    @if (
                      !hasUserDeliveryAccess ||
                      userActiveDeliveryProductIdsValue.length === 0
                    ) {
                      <fa-icon
                        [icon]="['far', 'times']"
                        [ngStyle]="{ color: 'red' }">
                      </fa-icon>
                    }
                  </td>
                  <!--App Access Column-->
                  <td align="center">
                    @let hasUserAppAccess = 'app' | hasUserAccess: user;
                    @if (hasUserAppAccess) {
                      <span
                        matTooltip="{{
                          'PRODUCT.USERADMIN.USERLIST.ACCESSUNLIMITED'
                            | translate
                        }}">
                        @let isUserAllowedToAccessAllAppProducts =
                          'app' | isUserAllowedToAccessAllProducts: user;
                        @if (isUserAllowedToAccessAllAppProducts) {
                          <fa-icon
                            [icon]="['far', 'check-double']"
                            [ngStyle]="{ color: 'green' }"></fa-icon>
                        } @else {
                          <ng-container
                            *ngTemplateOutlet="notAllOnlineProducts">
                          </ng-container>
                        }
                      </span>
                    } @else {
                      <ng-container *ngTemplateOutlet="noOnlineAccess">
                      </ng-container>
                    }
                  </td>
                  <td>
                    <button
                      mat-icon-button
                      class="btn-app-delete"
                      (click)="onDeleteUser(user)">
                      <fa-icon
                        [icon]="['far', 'trash']"
                        [ngStyle]="{ color: 'red' }"
                        size="lg"></fa-icon>
                    </button>
                  </td>
                </tr>
              }
            }
          </table>

          <mat-paginator
            [showFirstLastButtons]="true"
            [length]="userListValue.length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="onChangePage($event)">
          </mat-paginator>
          <div style="display: flex; justify-content: space-between">
            <span
              ><fa-icon
                [icon]="['far', 'check']"
                style="color: green"></fa-icon>
              &nbsp; {{ 'PRODUCT.USERADMIN.ACTIVE' | translate }}</span
            >
            <span
              ><fa-icon [icon]="['far', 'times']" style="color: red"></fa-icon>
              &nbsp; {{ 'PRODUCT.USERADMIN.NOT_ACTIVE' | translate }}</span
            >
            <span
              ><fa-icon
                [icon]="['far', 'infinity']"
                style="color: green"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.USERADMIN.RUNTIME_ENDLESS' | translate }}</span
            >
            <span
              ><fa-icon
                [icon]="['far', 'calendar-check']"
                style="color: green"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.USERADMIN.RUNTIME_LIMITED' | translate }}</span
            >
            <span
              ><fa-icon
                [icon]="['far', 'calendar-times']"
                style="color: red"></fa-icon>
              &nbsp; {{ 'PRODUCT.USERADMIN.RUNTIME_OVER' | translate }}</span
            >
            <span
              ><fa-icon
                [icon]="['far', 'calendar-star']"
                style="color: grey"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.USERADMIN.NOT_YET_STARTED' | translate }}</span
            >
            <span
              ><fa-icon
                [icon]="['far', 'check-double']"
                style="color: green"></fa-icon>
              &nbsp; {{ 'PRODUCT.USERADMIN.ALL_SELECTED' | translate }}</span
            >
            <span
              ><fa-icon
                [icon]="['far', 'tasks']"
                style="color: green"></fa-icon>
              &nbsp; {{ 'PRODUCT.USERADMIN.SELECTION' | translate }}</span
            >
            <span
              ><fa-icon [icon]="['far', 'trash']" style="color: red"></fa-icon>
              &nbsp; {{ 'PRODUCT.USERADMIN.REMOVE_USER' | translate }}</span
            >
          </div>
        </div>
      }
    } @else {
      <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
      </app-loading-overlay>
    }
  </mat-card>
} @else if (editViewValue && userService.userData() | isNotEmptyObject) {
  @let newUserValue = newUser();
  <mat-card appearance="outlined">
    @if (newUserValue) {
      <h1 class="mat-h1">
        {{ 'PRODUCT.USERADMIN.NEWUSER' | translate }}
      </h1>
    } @else {
      <h1 class="mat-h1">
        {{ 'PRODUCT.USERADMIN.EDITUSER' | translate }}:
        {{ formGroupStammdatenControlNameValue() }} [{{
          formGroupStammdatenControlEmailValue()
        }}]
      </h1>
    }
    <!--Stepper-->
    <mat-stepper
      orientation="horizontal"
      [linear]="newUserValue"
      #stepper
      (selectionChange)="onStepperSelectionChanged($event)">
      <!--Step Stammdaten-->
      @let contingentsValue = contingents();
      @let deliveryTargetsValue = deliveryTargets();
      <mat-step [stepControl]="userService.formGroupStammdaten">
        <ng-template matStepLabel>
          <fa-icon [icon]="['far', 'address-card']" size="lg"></fa-icon>
          &nbsp; {{ 'PRODUCT.USERADMIN.STAMMDATEN.TITLE' | translate }}
        </ng-template>
        <app-users-tab-master-data
          [newUser]="newUserValue"
          [(isEditingUserName)]="isEditingUserName"
          [deliveryTargetIcons]="deliveryTargetIcons"
          [deliveryTargets]="deliveryTargetsValue"
          [contingents]="contingentsValue"
          [separatorKeysCodes]="separatorKeysCodes"
          [isSaving]="isSavingValue"
          (cancel)="onCancel()"
          (checkEmailToAddToDeliveryTargets)="
            onCheckEmailToAddToDeliveryTargets()
          "
          (remove)="remove($event)"
          (add)="add($event)"
          (autoDelivery)="onAutoDelivery($event)"
          (doSubmit)="onSubmit()"
          (summarizeUser)="onSummarizeUser()">
        </app-users-tab-master-data>
      </mat-step>
      @let productListValue = productList();
      <!--Step Website-->
      <mat-step [stepControl]="userService.formGroupWebsite">
        <ng-template matStepLabel>
          <fa-icon [icon]="['far', 'globe']" size="lg"></fa-icon>
          &nbsp; {{ 'HOME.BRAND' | translate }}
          {{ 'PRODUCT.USERADMIN.WEBSITE.TITLE' | translate }}
        </ng-template>
        <app-users-tab-website
          [newUser]="newUserValue"
          [isSaving]="isSavingValue"
          [contingents]="contingentsValue"
          [buttonsTemplate]="buttonsTemplate"
          [productList]="productListValue"
          [eopTypes]="eopTypes"
          [egpTypes]="egpTypes"
          (clickSectionCheckbox)="onClickSectionCheckbox($event)"
          (clickAllProducts)="onClickAllProducts($event)"
          (expandedChanged)="onExpandedChanged($event)"
          (userStationChange)="onUserStationChange($event)"
          (userProductChange)="onUserProductChange($event)"
          (cancel)="onCancel()"
          (summarizeUser)="onSummarizeUser()"></app-users-tab-website>
      </mat-step>
      <!--Step Delivery(Versand)-->
      <mat-step [stepControl]="userService.formGroupDelivery">
        <ng-template matStepLabel>
          <fa-icon [icon]="['far', 'paper-plane']" size="lg"></fa-icon>
          &nbsp;
          {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}</ng-template
        >
        <app-users-tab-shipping
          [egwsummerThresholdOptions]="egwsummerThresholdOptions"
          [newUser]="newUserValue"
          [isSaving]="isSavingValue"
          [isMaster]="isMaster()"
          [isDeliveryActive]="isDeliveryActive"
          [deliveryTargetIcons]="deliveryTargetIcons"
          [contingents]="contingentsValue"
          [deliveryTargets]="deliveryTargetsValue"
          [separatorKeysCodes]="separatorKeysCodes"
          [buttonsTemplate]="buttonsTemplate"
          [productList]="productListValue"
          [eopTypesWithDelivery]="eopTypesWithDelivery"
          [egpTypes]="egpTypes"
          [egwgmaSmsPause]="egwgmaSmsPause"
          [egwsummerConfig]="egwsummerConfig"
          (deliverySeyActive)="onDeliverySetActive($event)"
          (remove)="remove($event)"
          (add)="add($event)"
          (expandedChanged)="onExpandedChanged($event)"
          (deliveryChange)="
            onDeliveryChange($event.event, $event.product, $event.formControl)
          "
          (smsPauseChange)="onSmsPauseChange($event)"
          (changePause)="
            onChangePause($event.productType, $event.section, $event.event)
          "
          (cancel)="onCancel()"
          (summarizeUser)="onSummarizeUser()">
        </app-users-tab-shipping>
      </mat-step>
      <!--Step Eisatzwetter App-->
      <mat-step [stepControl]="userService.formGroupApp">
        <ng-template matStepLabel>
          <fa-icon [icon]="['far', 'mobile']" size="lg"></fa-icon>
          &nbsp; {{ 'HOME.BRAND' | translate }}
          {{ 'PRODUCT.USERADMIN.APP.TITLE' | translate }}
        </ng-template>
        <app-users-tab-app
          [newUser]="newUserValue"
          [isSaving]="isSavingValue"
          [contingents]="contingentsValue"
          [buttonsTemplate]="buttonsTemplate"
          [productList]="productListValue"
          [eopTypes]="eopTypes"
          [egpTypes]="egpTypes"
          (clickSectionCheckbox)="onClickSectionCheckbox($event)"
          (clickAllProducts)="onClickAllProducts($event)"
          (expandedChanged)="onExpandedChanged($event)"
          (userStationChange)="onUserStationChange($event)"
          (userProductChange)="onUserProductChange($event)"
          (cancel)="onCancel()"
          (summarizeUser)="onSummarizeUser()">
        </app-users-tab-app>
      </mat-step>
      <!--Step Summary-->
      <mat-step>
        <ng-template matStepLabel>{{
          'PRODUCT.USERADMIN.SUMMARIZE' | translate
        }}</ng-template>
        <mat-card appearance="outlined">
          <div class="form-column-left">
            <fa-icon
              [icon]="['far', 'check-circle']"
              size="4x"
              style="color: grey"></fa-icon>
          </div>
          <div class="form-column-right">
            @let wasUserDataChangedValue = wasUserDataChanged();
            @if (newUserValue && wasUserDataChangedValue) {
              <p>
                {{ 'PRODUCT.USERADMIN.FINISHED' | translate }}
              </p>
            }

            @if (!newUserValue && !wasUserDataChangedValue) {
              <button mat-button color="success">
                {{ 'PRODUCT.USERADMIN.NOCHANGES' | translate }}
              </button>
            }
            @if (
              !newUserValue &&
              wasUserDataChangedValue &&
              formChangesDetailsLength() > 0
            ) {
              <h3>{{ 'PRODUCT.USERADMIN.THESECHANGES' | translate }}:</h3>
              <table>
                @for (detail of changeDetails(); track $index) {
                  <tr>
                    <td>
                      {{
                        'PRODUCT.USERADMIN.' + detail.name + '.TITLE'
                          | translate
                      }}:
                    </td>
                    <td>
                      @for (field of detail.changedFields; track $index) {
                        <mat-chip-option>
                          {{
                            'PRODUCT.USERADMIN.' +
                              detail.name +
                              '.' +
                              (field | uppercase) | translate
                          }}
                        </mat-chip-option>
                      }
                      &nbsp;
                    </td>
                  </tr>
                }
              </table>
            }
          </div>
          <div class="clear"></div>
        </mat-card>
        <br />
        <div>
          <button
            mat-raised-button
            class="btn-app-cancel"
            type="button"
            (click)="onCancel()">
            {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
          </button>
          &nbsp;
          <button
            mat-raised-button
            class="btn-app-back"
            type="button"
            matStepperPrevious>
            {{ 'PRODUCT.USERADMIN.BACK' | translate }}
          </button>
          &nbsp;
          <button
            mat-raised-button
            class="btn-app-save"
            [disabled]="isSavingValue || loadingUserListValue"
            matStepperNext
            (click)="onSubmit()">
            {{ 'PRODUCT.USERADMIN.SAVE' | translate }}
          </button>
        </div>
      </mat-step>
    </mat-stepper>
  </mat-card>
}

<ng-template #buttonsTemplate let-section="section">
  <div style="display: flex; flex-wrap: wrap">
    @let buttonSelectedValue = buttonSelected();
    @if (buttonSelectedValue.allProducts[section]) {
      <button
        mat-raised-button
        color="primary"
        (click)="onSelectButShowAllProducts(section)">
        {{ 'PRODUCT.USERADMIN.SELECTALL' | translate }}
      </button>
    } @else {
      <button
        mat-button
        color="primary"
        (click)="onSelectButShowAllProducts(section)">
        {{ 'PRODUCT.USERADMIN.SELECTALL' | translate }}
      </button>
    }
    @if (buttonSelectedValue.noProducts[section]) {
      <button
        mat-raised-button
        color="primary"
        (click)="onUnselectAllProducts(section)">
        {{ 'PRODUCT.USERADMIN.SELECTNONE' | translate }}
      </button>
    } @else {
      <button
        mat-button
        color="primary"
        (click)="onUnselectAllProducts(section)">
        {{ 'PRODUCT.USERADMIN.SELECTNONE' | translate }}
      </button>
    }
    @if (!buttonSelectedValue.expandAll[section]) {
      <button mat-button color="primary" (click)="onExpandAll(section)">
        {{ 'PRODUCT.USERADMIN.EXPANDALL' | translate }}
      </button>
    } @else {
      <button mat-raised-button color="primary" (click)="onExpandAll(section)">
        {{ 'PRODUCT.USERADMIN.EXPANDALL' | translate }}
      </button>
    }
    @if (!buttonSelectedValue.collapseAll[section]) {
      <button mat-button color="primary" (click)="onCollapseAll(section)">
        {{ 'PRODUCT.USERADMIN.COLLAPSEALL' | translate }}
      </button>
    } @else {
      <button
        mat-raised-button
        color="primary"
        (click)="onCollapseAll(section)">
        {{ 'PRODUCT.USERADMIN.COLLAPSEALL' | translate }}
      </button>
    }
  </div>
</ng-template>

<ng-template #noOnlineAccess>
  <span matTooltip="{{ 'PRODUCT.USERADMIN.USERLIST.NOACCESS' | translate }}">
    <fa-icon [icon]="['far', 'times']" [ngStyle]="{ color: 'red' }"></fa-icon>
  </span>
</ng-template>

<ng-template #notAllOnlineProducts>
  <span
    matTooltip="{{ 'PRODUCT.USERADMIN.USERLIST.ACCESSLIMITED' | translate }}">
    <fa-icon [icon]="['far', 'tasks']" [ngStyle]="{ color: 'green' }"></fa-icon>
  </span>
</ng-template>
